import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import moment from 'moment';

import { SCHEDULE_DAYS_NUMBER, SCHEDULER } from 'constant/constants';

export const addAdditionHours = (weekday, type, startTime = null, endTime = null) => ({
  id: uuidv4(),
  weekday,
  type,
  startTime,
  endTime,
});

export const getOperationalHours = (hours = []) => {
  let openingHours = [];
  let dataListByDays = {};

  hours.forEach(({ end_time, start_time, type, weekday, platform }) => {
    if (!openingHours.find(({ day }) => day === SCHEDULE_DAYS_NUMBER[weekday])) {
      openingHours.push({
        type,
        isOpen: true,
        startTime: start_time,
        endTime: end_time,
        dataList: [],
        day: SCHEDULE_DAYS_NUMBER[weekday],
        platform,
      });
    } else {
      const dataList = dataListByDays[SCHEDULE_DAYS_NUMBER[weekday]] || [];
      dataListByDays = {
        ...dataListByDays,
        [SCHEDULE_DAYS_NUMBER[weekday]]: [...dataList, addAdditionHours(weekday, type, start_time, end_time)],
      };
    }
  });

  return SCHEDULER.map((hour) => {
    const hour_ = openingHours.find(({ day }) => day === hour.day) || hour;
    const dataList = dataListByDays[hour_.day] || [];
    return { ...hour_, dataList };
  });
};

export const getSpecialHours = (hours = []) => {
  return _.chain(hours)
    .map((hour) => {
      const diff = Math.floor(moment(hour.end_date, 'YYYY-MM-DD').diff(moment(hour.start_date, 'YYYY-MM-DD'), 'day'));
      return new Array(diff + 1).fill(0).map((notuse, idx) => ({
        day: moment(hour.start_date, 'YYYY-MM-DD').add(idx, 'day').toISOString(),
        startTime: hour.start_time,
        endTime: hour.end_time,
        isOpen: hour.is_open,
        platform: hour.platform,
        type: hour.type,
      }));
    })
    .flatten()
    .uniqBy('day')
    .value();
};
